import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReimbursementService } from '../reimbursement.service';
import { ListDepartments } from '../reimbursement.interfaces';
import { FlashService } from '../../flash/flash.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-reimbursement.manager-view',
  templateUrl: './reimbursement-manager-view.component.html',
  styleUrls: ['./reimbursement-manager-view.component.css']
})
export class ReimbursementManagerViewComponent implements OnInit {
  sub
  id;
  public userData;
  status: ListDepartments[];
  statusKey;
  comment;
  rejectedKey;
  approvedFeedbackKey;
  accepted;
  approval_cost;
  changedCostItems: any = [];
  approvedCostItems: any = [];
  approvedId: any = [];
  approval: boolean;
  approvalhide;
  totalCost;
  payTypes;
  payDetail;
  user;
  reimbursement_manager;
  isSelected;
  paymentTypes = [
    {
      'key': 'Cash',
      'value': 'Cash'
    },
    {
      'key': 'Google Pay',
      'value': 'Google Pay',
    }, {
      'key': ' Phone Pe',
      'value': 'Phone Pe',
    },
    {
      'key': 'NEFT/IMPS',
      'value': 'NEFT',
    }
  ]
  constructor(private reimbur: ReimbursementService,
    private route: ActivatedRoute, private location: Location,
    private router: Router, private flashService: FlashService,
  ) {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.user.roles.forEach(roles => {
      if (roles == 'reimbursement_manager') {
        this.reimbursement_manager = roles;
      }
    });
  }

  ngOnInit() {
    this.totalCost = 0;
    this.userData = this.reimbur.reimbursementUserList;
    this.userData.items.map(c => { this.totalCost += c.cost });
    this.sub = this.route.params.subscribe(params => {
      this.id = params['id'];
    });

    this.statusList();
    this.approval = this.reimbur.approval;
    this.approvalhide = this.reimbur.rejectApprovalCost;
    this.payDetail = this.userData.payment_details;
    this.payTypes = this.userData.payment_type;
  }

  trackByFn(index) {
    return index;
  }

  statusList() {
    this.reimbur.getListStatus().subscribe(status => {
      status.filter(status => {
        if (status.key === "approved") {
          this.statusKey = status.key;
        }
        if (status.key === "rejected") {
          this.rejectedKey = status.key;
        }

        if (status.key === "paid") {
          this.accepted = status.key;
        }
      });
    });
  }

  costForApproved(cost, itemChanged) {
    let totalCost = 0;
    let costElements: any = document.getElementById("manager-table").getElementsByClassName('item-cost');
    for (let item of costElements) {
      totalCost += Number(item.value);
    }
    this.totalCost = totalCost;
    this.approval_cost = cost;
    if (this.approval_cost) {
      this.approvedCostItems = this.approvedCostItems.filter((val) => val.id != itemChanged.id)
      const currentItemChanges = {
        id: itemChanged.id,
        approval_cost: this.approval_cost
      }
      this.approvedCostItems.push(currentItemChanges);
    }
  }

  locationBack() {
    this.location.back();
  }

  onComment(event) {
    this.comment = event.target.value;
  }

  paymentType(paymentType) {
    if (paymentType) {
      if (paymentType == "Cash") {
        this.isSelected = true;
        this.payTypes = paymentType;

      } else {
        this.payTypes = paymentType;
        this.isSelected = false;
      }
    }
  }

  paymentDetails(paymentDetail) {
    if (paymentDetail) {
      this.payDetail = paymentDetail;
    }
  }
  goToFile(url) {
    window.location.assign(url);
  }
  managerApproval() {
    let final = {
      comment: this.comment,
      payment_type: this.payTypes,
      payment_details: this.payDetail,
      items: []
    }
    this.approvedId = this.approvedCostItems.map(id => {
      return id.id;
    });
    this.userData.items.forEach(c => {
      if (!this.approvedCostItems.length) {
        const currentItemChanges = {
          id: c.id,
          approval_cost: c.cost
        }
        final.items.push(currentItemChanges);
      }
      this.approvedCostItems.forEach(element => {
        if (c.id === element.id) {
          const currentItemChanges = {
            id: element.id,
            approval_cost: Number(element.approval_cost)
          }
          final.items.push(currentItemChanges);
        }
        else if (!this.approvedId.includes(c.id)) {
          const currentItemChanges = {
            id: c.id,
            approval_cost: c.cost
          }

          final.items.push(currentItemChanges);
        }

      });
    });

    this.reimbur.getApproval(final, this.id, this.statusKey).subscribe(approval => {
      this.flashService.show(approval['message'], 'alert-success');
      this.router.navigate(['/reimbursement/manager/list']);
    });
  }



  managerReject() {
    let final = {
      comment: this.comment,
      items: []
    }
    this.approvedId = this.approvedCostItems.map(id => {
      return id.id;
    });
    this.userData.items.forEach(c => {
      if (this.approvedCostItems.length == 0) {
        const currentItemChanges = {
          id: c.id,
          approval_cost: c.cost,
        }
        final.items.push(currentItemChanges);
      }
      this.approvedCostItems.forEach(element => {
        if (c.id === element.id) {
          const currentItemChanges = {
            id: element.id,
            approval_cost: Number(element.approval_cost)
          }

          final.items.push(currentItemChanges);

        }
        else if (!this.approvedId.includes(c.id)) {
          const currentItemChanges = {
            id: c.id,
            approval_cost: c.cost
          }
          final.items.push(currentItemChanges);
        }
        else if (!this.approvedId) {

        }
      });
    });
    this.reimbur.getRejected(final, this.id, this.rejectedKey).subscribe(rejected => {
      this.flashService.show(rejected['message'], 'alert-success');
      this.router.navigate(['/reimbursement/manager/list']);
    });
  }


}


// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/reimbursement/reimbursement-manager-view/reimbursement-manager-view.component.ts